import { render, staticRenderFns } from "./CatalogProductSettingSection.vue?vue&type=template&id=bc6190c8&"
import script from "./CatalogProductSettingSection.vue?vue&type=script&lang=js&"
export * from "./CatalogProductSettingSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports